import { HubConnectionBuilder, HubConnection, HubConnectionState } from "@microsoft/signalr";

class ChatClient {
    Connection: HubConnection | undefined;
    IntervalId: number | undefined;

    public async Start(
        componentReference: any,
        hubUrl: string,
        hubMethod: string,
        hubCallback: string,
        interopMethodName: string) {

        if (!this.Connection) {
            // key is the unique key we use to store/retrieve connections
            console.log("Connection start");

            // create a client
            console.log("Connection being started for " + hubUrl);
            this.Connection = new HubConnectionBuilder()
                .withUrl(hubUrl)
                .build();

            console.log("Connection created, adding receive handler");

            // create an inbound message handler for the "ReceiveMessage" event
            this.Connection.on(hubCallback, async () => {
                await componentReference.invokeMethodAsync(interopMethodName)
            });

            // start the connection
            var result = this.Connection.start().then(async () => {
                if (this.Connection) {
                    try {
                        await this.Connection.invoke<boolean>(hubMethod);
                    }
                    catch (e) {
                        console.error(e);
                    }

                    this.IntervalId = window.setInterval(async () => {
                        if (this.Connection && this.Connection.state === HubConnectionState.Connected) {
                            try {
                                await this.Connection.invoke<boolean>(hubMethod);
                            }
                            catch (e) {
                                console.error(e);
                            }
                        }
                    }, 5000);
                }
            });

            console.log("Connection start: returning a promise?");
            console.log(result);
            return result;
        }
    }

    public async Stop() {
        console.log("Connection stop request");
        // locate the SignalR connection
        if (this.IntervalId) {
            window.clearInterval(this.IntervalId);
            this.IntervalId = undefined;
        }
        if (this.Connection) {
            var result = await this.Connection.stop();
            console.log("Connection stopping");
            this.Connection = undefined;
            return result;
        }
        else {
            console.log("Nothing to disconnect from");
        }
        return null;
    }
}

const chatClient = new ChatClient();
export { chatClient };